import Can from "./can";
import User from "../models/user";
import UserDecorator from "../../formability/admin/models/userDecorator";
import {ICapable} from "../interfaces/capableInterfaces";

export default class BaseCan extends Can {
  constructor(user: ICapable) {
    super(user);

    this.iCan('viewOrganizationManagement', [User, UserDecorator], () => {
      return this.basicCan(user) && user.base_capabilities.organization_management.show;
    });

    this.iCan('viewDocumentManagement', [User, UserDecorator], () => {
      return this.basicCan(user) && user.base_capabilities.document_management.show;
    });

    this.iCan('viewPortalManagement', [User, UserDecorator], () => {
      return this.basicCan(user) && user.base_capabilities.portal_management.show;
    });

    this.iCan('viewReportingDashboard', [User, UserDecorator], () => {
      return this.basicCan(user) && user.base_capabilities.analyst_dashboard.manage;
    });

    this.iCan('viewOrganizationSettings', [User, UserDecorator], () => {
      return this.basicCan(user) && user.base_capabilities.organization_settings.show;
    });

    this.iCan('viewDashboardAnalyticsManager', [User, UserDecorator], () => {
      return this.basicCan(user) && user.base_capabilities.analytics_dashboard_manager.manage
    });

    this.iCan('createNewOrganization', [User, UserDecorator], () => {
      return this.basicCan(user) && user.is_admin;
    });
  }

  private basicCan(user: ICapable): boolean {
    return !!user.base_capabilities;
  }
}
